export const ABORT = 'Abort'
export const CANCEL = 'Cancel'
export const CHECK = 'Check'
export const KEEPALIVE = '_Keepalive'
export const POS_MESSAGE = 'PosMessage'
export const PRINT = 'Print'
export const PURCHASE = 'Purchase'
export const REFUND = 'Refund'
export const STATUS = 'Status'
export const STATUS_EVENT = 'StatusEvent'
export const TERMINAL_INFO = 'TerminalInfo'
